import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import NavItem from './nav-item';
import DownIcon from 'grommet/components/icons/base/Down';
import Utils from 'medscape/utils';

export default class NavMenu extends React.Component{
    constructor(props){
        super(props);
        //console.log("Nav Menu Constructor:",props);
    }

    shouldComponentUpdate(nextProps, nextState){
        return true;
    }
    componentWillUpdate(nextProps, nextState){ 

       //console.log("Nav Menu Will Update", nextProps)
    }
    getNavItems() {
        let NavItems = this.props.items;
        let items = NavItems.map( (Item,index) => {
            let itemKey = `${Item.title}-${index}`;
            const NavItemProps = {
                key: itemKey,
                item: Item,
                settings: this.props.settings,
                route: this.props.route,
                isSubmenuItem: this.props.isSubmenu,
                onItemClick: this.props.onItemClick,
                onMouseEnter: this.props.onItemMouseEnter,
                onMouseLeave: this.props.onItemMouseLeave
            }
            return(
                <NavItem {...NavItemProps }/>
            );
            
        });
        return items;
    } // getNavItems

    render() { 
        let items = this.props.items;
        if(items.length==0){
            return false;
        }
        let navItems = this.getNavItems();
        let className = this.props.isSubmenu ? 'sub-menu' : 'nav-menu';
        return (
            <ul className={ className }>
                { navItems }
            </ul>
        );

    }

}
NavMenu.propTypes={
    items: React.PropTypes.array,
    settings: React.PropTypes.object.isRequired,
    route: React.PropTypes.object.isRequired,
    isSubmenu: React.PropTypes.bool,
    onItemClick: React.PropTypes.func,
    onItemMouseEnter: React.PropTypes.func,
    onItemMouseLeave: React.PropTypes.func
}
NavMenu.defaultProps={
    items: [],
    className: '',
    isSubmenu: false,
    onItemClick: ()=>{},
    onMouseLeave: ()=>{},
    onMouseEnter: ()=>{}
}



// WEBPACK FOOTER //
// ./src/app/navigation/nav-menu.jsx